import '../App.css'
import { createTheme} from '@mui/material/styles';

export const globalTheme = createTheme(({
    palette: {
        primary: {
            //main: "rgba(253, 236, 239, 1)",
            main: "rgb(218, 232, 248)"
        },
        secondary: {
            main: "#bcd1eb"
            // main: "#95b4da",
        },
        heading:{
            color: "rgb(218, 232, 248)",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"]
        },
        dividerColor: {
            //backgroundColor: "rgb(23, 26, 33)",
            backgroundColor: "rgb(165, 170, 182)",
            border: "none",
            height: "4px",
        }
    },
    typography: {
        // color: "#bcd1eb",
        // fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
        heading:{
            color: "#bcd1eb",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
        },
        h1:{
            color: "#bcd1eb",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
        },
        h6:{
            color: "#bcd1eb",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
        },
        body1:{
            color: "#9bb2cf",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"]
        },
        subtitle1:{
            color: "#9bb2cf",
            fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"]
        },
    },
}));

export default globalTheme;